import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  URLBuilder1hwx1b9569i61 as URLBuilder,
  takeFromkqlcz7c6dx2r as takeFrom,
} from '../../../../../ktor-ktor-http/io/ktor/http/URLUtils.mjs';
import { ParametersBuilder1ry9ntvvg567r as ParametersBuilder } from '../../../../../ktor-ktor-http/io/ktor/http/Parameters.mjs';
import { appendAlltwnjnu28pmtx as appendAll } from '../../../../../ktor-ktor-utils/io/ktor/util/StringValues.mjs';
import { first58ocm7j58k3q as first } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { checkBuilderCapacity1h6g02949wvv as checkBuilderCapacity } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
import { get_ENGINE_CAPABILITIES_KEYr1fjz8liznxo as get_ENGINE_CAPABILITIES_KEY } from '../engine/HttpClientEngineCapability.mjs';
import { KtMap140uvy3s5zad8 as KtMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import { Phases_getInstance1dciif7svdqxc as Phases_getInstance } from '../request/HttpRequestPipeline.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HeadersBuilder3h7sn3kkvu98m as HeadersBuilder } from '../../../../../ktor-ktor-http/io/ktor/http/Headers.mjs';
import { URLBuilder2mz8zkz4u9ray as URLBuilder_0 } from '../../../../../ktor-ktor-http/io/ktor/http/URLBuilder.mjs';
import { AttributesJsFn25rjfgcprgprf as AttributesJsFn } from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.web.mjs';
import { takeFrom3rd40szpqy350 as takeFrom_0 } from '../../../../../ktor-ktor-http/io/ktor/http/URLParser.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_LOGGER() {
  _init_properties_DefaultRequest_kt__yzsodq();
  return LOGGER;
}
var LOGGER;
function defaultRequest(_this__u8e3s4, block) {
  _init_properties_DefaultRequest_kt__yzsodq();
  var tmp = Plugin_getInstance();
  return _this__u8e3s4.install_6m4asv_k$(tmp, ($this$install) => {
    block($this$install);
    return Unit_instance;
  });
}
function mergeUrls($this, baseUrl, requestUrl) {
  if (requestUrl.protocolOrNull_1 == null) {
    requestUrl.protocolOrNull_1 = baseUrl.protocolOrNull_1;
  }
  // Inline function 'kotlin.text.isNotEmpty' call
  var this_0 = requestUrl.host_1;
  if (charSequenceLength(this_0) > 0)
    return Unit_instance;
  var resultUrl = URLBuilder(baseUrl);
  // Inline function 'kotlin.with' call
  resultUrl.protocolOrNull_1 = requestUrl.protocolOrNull_1;
  if (!(requestUrl.port_1 === 0)) {
    resultUrl.set_port_gcpocq_k$(requestUrl.port_1);
  }
  resultUrl.encodedPathSegments_1 = concatenatePath(Plugin_getInstance(), resultUrl.encodedPathSegments_1, requestUrl.encodedPathSegments_1);
  // Inline function 'kotlin.text.isNotEmpty' call
  var this_1 = requestUrl.encodedFragment_1;
  if (charSequenceLength(this_1) > 0) {
    resultUrl.encodedFragment_1 = requestUrl.encodedFragment_1;
  }
  // Inline function 'kotlin.apply' call
  var this_2 = ParametersBuilder();
  appendAll(this_2, resultUrl.encodedParameters_1);
  var defaultParameters = this_2;
  resultUrl.set_encodedParameters_t3ck1r_k$(requestUrl.encodedParameters_1);
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = defaultParameters.entries_qbkxv4_k$().iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    // Inline function 'kotlin.collections.component1' call
    var key = element.get_key_18j28a_k$();
    // Inline function 'kotlin.collections.component2' call
    var values = element.get_value_j01efc_k$();
    if (!resultUrl.encodedParameters_1.contains_zh0gsb_k$(key)) {
      resultUrl.encodedParameters_1.appendAll_ytnfgb_k$(key, values);
    }
  }
  takeFrom(requestUrl, resultUrl);
}
function concatenatePath($this, parent, child) {
  if (child.isEmpty_y1axqb_k$())
    return parent;
  if (parent.isEmpty_y1axqb_k$())
    return child;
  // Inline function 'kotlin.text.isEmpty' call
  var this_0 = first(child);
  if (charSequenceLength(this_0) === 0)
    return child;
  // Inline function 'kotlin.collections.buildList' call
  // Inline function 'kotlin.collections.buildListInternal' call
  var capacity = (parent.get_size_woubt6_k$() + child.get_size_woubt6_k$() | 0) - 1 | 0;
  checkBuilderCapacity(capacity);
  // Inline function 'kotlin.apply' call
  var this_1 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(capacity);
  var inductionVariable = 0;
  var last = parent.get_size_woubt6_k$() - 1 | 0;
  if (inductionVariable < last)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      this_1.add_utx5q5_k$(parent.get_c1px32_k$(index));
    }
     while (inductionVariable < last);
  this_1.addAll_h3ej1q_k$(child);
  return this_1.build_nmwvly_k$();
}
function DefaultRequest$Plugin$install$slambda$lambda() {
  // Inline function 'kotlin.collections.mutableMapOf' call
  return LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
}
function DefaultRequest$Plugin$install$slambda($plugin) {
  return constructCallableReference(($this$intercept, it, $completion) => orPromise($completion, function *($completion) {
    var originalUrlString = $this$intercept.context_1.url_1.toString();
    // Inline function 'kotlin.apply' call
    var this_0 = new (DefaultRequestBuilder())();
    appendAll(this_0.headers_1, $this$intercept.context_1.headers_1);
    var userHeaders = this_0.headers_1.build_1k0s4u_k$();
    $plugin.block_1(this_0);
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = userHeaders.entries_qbkxv4_k$().iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      $l$block_0: {
        // Inline function 'kotlin.collections.component1' call
        var key = element.get_key_18j28a_k$();
        // Inline function 'kotlin.collections.component2' call
        var oldValues = element.get_value_j01efc_k$();
        var newValues = this_0.headers_1.getAll_ffxf4h_k$(key);
        if (newValues == null) {
          this_0.headers_1.appendAll_ytnfgb_k$(key, oldValues);
          break $l$block_0;
        }
        if (equals(newValues, oldValues) || key === 'Cookie') {
          break $l$block_0;
        }
        this_0.headers_1.remove_6241ba_k$(key);
        this_0.headers_1.appendAll_ytnfgb_k$(key, oldValues);
        this_0.headers_1.appendMissing_dlfvfk_k$(key, newValues);
      }
    }
    var defaultRequest = this_0;
    var defaultUrl = defaultRequest.url_1.build_1k0s4u_k$();
    mergeUrls(Plugin_getInstance(), defaultUrl, $this$intercept.context_1.url_1);
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = defaultRequest.attributes_1.get_allKeys_dton90_k$().iterator_jk1svi_k$();
    while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
      var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
      if (element_0.equals(get_ENGINE_CAPABILITIES_KEY())) {
        var tmp = get_ENGINE_CAPABILITIES_KEY();
        var capabilities = $this$intercept.context_1.attributes_1.computeIfAbsent_c4qp5i_k$(tmp, DefaultRequest$Plugin$install$slambda$lambda);
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s_1 = defaultRequest.attributes_1.get_r696p5_k$(get_ENGINE_CAPABILITIES_KEY()).get_entries_p20ztl_k$().iterator_jk1svi_k$();
        while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
          var _destruct__k2r9zo = _iterator__ex2g4s_1.next_20eer_k$();
          // Inline function 'kotlin.collections.component1' call
          var key_0 = _destruct__k2r9zo.get_key_18j28a_k$();
          // Inline function 'kotlin.collections.component2' call
          var value = _destruct__k2r9zo.get_value_j01efc_k$();
          // Inline function 'kotlin.collections.contains' call
          // Inline function 'kotlin.collections.containsKey' call
          if (!(isInterface(capabilities, KtMap()) ? capabilities : THROW_CCE()).containsKey_aw81wo_k$(key_0)) {
            // Inline function 'kotlin.collections.set' call
            capabilities.put_4fpzoq_k$(key_0, value);
          }
        }
      } else if (!$this$intercept.context_1.attributes_1.contains_du0289_k$(element_0)) {
        $this$intercept.context_1.attributes_1.put_gkntno_k$(element_0 instanceof AttributeKey() ? element_0 : THROW_CCE(), defaultRequest.attributes_1.get_r696p5_k$(element_0));
      }
    }
    $this$intercept.context_1.headers_1.clear_j9egeb_k$();
    $this$intercept.context_1.headers_1.appendAll_k8dlt1_k$(defaultRequest.headers_1.build_1k0s4u_k$());
    get_LOGGER().trace_fti9bv_k$('Applied DefaultRequest to ' + originalUrlString + '. New url: ' + $this$intercept.context_1.url_1.toString());
    return Unit_instance;
  }), 2);
}
var PluginClass;
function Plugin() {
  if (PluginClass === VOID) {
    class $ {
      constructor() {
        Plugin_instance = this;
        var tmp = this;
        // Inline function 'io.ktor.util.AttributeKey' call
        var name = 'DefaultRequest';
        // Inline function 'io.ktor.util.reflect.typeInfo' call
        var tmp_0 = getKClass(DefaultRequest());
        // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
        var tmp_1;
        try {
          tmp_1 = createKType(getKClass(DefaultRequest()), arrayOf([]), false);
        } catch ($p) {
          var tmp_2;
          if ($p instanceof Error) {
            var _unused_var__etf5q3 = $p;
            tmp_2 = null;
          } else {
            throw $p;
          }
          tmp_1 = tmp_2;
        }
        var tmp$ret$2 = tmp_1;
        var tmp$ret$1 = new (TypeInfo())(tmp_0, tmp$ret$2);
        tmp.key_1 = new (AttributeKey())(name, tmp$ret$1);
      }
      get_key_18j28a_k$() {
        return this.key_1;
      }
      prepare_wirdac_k$(block) {
        return new (DefaultRequest())(block);
      }
      prepare_t1xtpw_k$(block) {
        return this.prepare_wirdac_k$(block);
      }
      install_txz2ej_k$(plugin, scope) {
        var tmp = Phases_getInstance().Before_1;
        scope.requestPipeline_1.intercept_k21bv3_k$(tmp, DefaultRequest$Plugin$install$slambda(plugin));
      }
      install_zd7cej_k$(plugin, scope) {
        return this.install_txz2ej_k$(plugin instanceof DefaultRequest() ? plugin : THROW_CCE(), scope);
      }
    }
    initMetadataForObject($, 'Plugin');
    PluginClass = $;
  }
  return PluginClass;
}
var Plugin_instance;
function Plugin_getInstance() {
  if (Plugin_instance === VOID)
    new (Plugin())();
  return Plugin_instance;
}
var DefaultRequestBuilderClass;
function DefaultRequestBuilder() {
  if (DefaultRequestBuilderClass === VOID) {
    class $ {
      constructor() {
        this.headers_1 = new (HeadersBuilder())();
        this.url_1 = new (URLBuilder_0())();
        this.attributes_1 = AttributesJsFn(true);
      }
      get_headers_ef25jx_k$() {
        return this.headers_1;
      }
      url_chgr8b_k$(urlString) {
        takeFrom_0(this.url_1, urlString);
      }
    }
    initMetadataForClass($, 'DefaultRequestBuilder');
    DefaultRequestBuilderClass = $;
  }
  return DefaultRequestBuilderClass;
}
var DefaultRequestClass;
function DefaultRequest() {
  if (DefaultRequestClass === VOID) {
    class $ {
      constructor(block) {
        Plugin_getInstance();
        this.block_1 = block;
      }
    }
    initMetadataForClass($, 'DefaultRequest');
    DefaultRequestClass = $;
  }
  return DefaultRequestClass;
}
var properties_initialized_DefaultRequest_kt_au5efk;
function _init_properties_DefaultRequest_kt__yzsodq() {
  if (!properties_initialized_DefaultRequest_kt_au5efk) {
    properties_initialized_DefaultRequest_kt_au5efk = true;
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.DefaultRequest');
  }
}
//region block: exports
export {
  defaultRequest as defaultRequest2ux1d5xxixv6z,
};
//endregion

//# sourceMappingURL=DefaultRequest.mjs.map
